// mqttService.jsx
import { useEffect, useState } from "react";
import mqtt from "mqtt";
import { useToken } from "./tokenContext";

const mqttUrlBase = process.env.REACT_APP_MQTT_URL;
const mqttTopic = process.env.REACT_APP_MQTT_TOPIC;
const mqttChartTopic = process.env.REACT_APP_MQTT_CHART_TOPIC;
const mqttUsernameEnv = process.env.REACT_APP_MQTT_USERNAME;
const mqttPasswordEnv = process.env.REACT_APP_MQTT_PASSWORD;
const environment = process.env.REACT_APP_ENVIRONMENT;
const project = process.env.REACT_APP_PROJECT;

const createMqttClient = (localViewGroup, onMessage) => {
  const mqttFullUrl = mqttUrlBase;

  const options = {
    username: mqttUsernameEnv,
    password: mqttPasswordEnv,
    reconnectPeriod: 10000,
  };

  const client = mqtt.connect(mqttFullUrl, options);

  client.on("connect", () => {
    const topic = `${environment}/${mqttTopic}/${project}/${localViewGroup}`;

    client.subscribe(topic, (err) => {
      if (err) {
        console.error("Erro ao se inscrever:", err);
      }
    });
  });

  client.on("message", (topic, message) => {
    try {
      const parsed = JSON.parse(message.toString());
      onMessage(parsed, parsed.type === "chart" ? "chart" : "default");
    } catch (err) {
      console.error("Erro MQTT:", err);
    }
  });

  client.on("error", (err) => console.error("Erro MQTT:", err));

  return client;
};

export const useMqtt = (key) => {
  const { token, userData } = useToken();
  const [messages, setMessages] = useState([]);
  const [chartMessages, setChartMessages] = useState([]);

  useEffect(() => {
    setMessages([]);
    setChartMessages([]);

    if (!mqttUrlBase || !mqttTopic || (!mqttUsernameEnv && !token)) {
      console.warn("MQTT incompleto, conexão não feita.");
      return;
    }

    const localViewGroup = userData?.filter?.id || "all";

    const client = createMqttClient(localViewGroup, (msg, type) => {
      if (type === "chart") {
        setChartMessages([msg]);
      } else {
        setMessages([msg]);
      }
    });

    return () => client?.end(true);
  }, [token, key, userData]);

  return { messages, chartMessages };
};

export const useMqttDinamometricCard = (key) => {
  const { token, userData } = useToken();
  const [lastNotification, setLastNotification] = useState(null);

  useEffect(() => {
    setLastNotification(null);

    if (!mqttUrlBase || !mqttChartTopic || (!mqttUsernameEnv && !token)) {
      console.warn("MQTT dinamométrico incompleto, conexão não feita.");
      return;
    }

    const localViewGroup = userData?.filter?.id || "all";

    const options = {
      username: mqttUsernameEnv,
      password: mqttPasswordEnv,
      reconnectPeriod: 10000,
    };

    const client = mqtt.connect(mqttUrlBase, options);

    client.on("connect", () => {
      const topic = `${environment}/${mqttChartTopic}/${project}/${localViewGroup}`;
      client.subscribe(topic, (err) => {
        if (err) console.error("Erro ao se inscrever (dinamométrico):", err);
      });
    });

    client.on("message", (_topic, message) => {
      try {
        const parsed = JSON.parse(message.toString());
        if (parsed?.id)
          setLastNotification({ assetId: parsed.id, ts: Date.now() });
      } catch (err) {
        console.error("Erro MQTT dinamométrico:", err);
      }
    });

    client.on("error", (err) => console.error("Erro MQTT dinamométrico:", err));

    return () => client?.end(true);
  }, [token, key, userData]);

  return { lastNotifiedAssetId: lastNotification?.assetId ?? null, lastNotification };
};
